import { ShieldCheck } from "lucide-react";

import { cn } from "@/lib/utils";

type AppLogoProps = {
  className?: string;
  compact?: boolean;
  primaryLabel?: string;
  secondaryLabel?: string;
};

// ponytail: no `tone` prop — these tokens already resolve per surface, in both themes.
export const AppLogo = ({
  className,
  compact = false,
  primaryLabel = "TaxOS Console",
  secondaryLabel = "by TUZIDI",
}: AppLogoProps) => (
  <div className={cn("flex items-center gap-2", className)} role="banner" aria-label="Application logo">
    <span className="border-border bg-muted/40 flex h-7 w-7 shrink-0 items-center justify-center rounded-md border">
      <ShieldCheck className="text-primary h-4 w-4" aria-hidden="true" />
    </span>
    {!compact ? (
      <div className="flex min-w-0 flex-col leading-tight">
        <span className="text-foreground truncate text-[13px] font-medium tracking-normal">{primaryLabel}</span>
        <span className="text-muted-foreground truncate text-[10px] font-normal tracking-tight">{secondaryLabel}</span>
      </div>
    ) : null}
  </div>
);
